import styled from 'styled-components';

const GroceriesProductName = styled.span`
  color: ${({ theme }) => theme.colors.night_blue_1};
  margin: ${({ theme }) => theme.spacing(4, 0, 2, 0)};
  max-width: 100px;
  overflow-wrap: break-word;
  min-height: 27px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallRegular};
`;

export default GroceriesProductName;
